
import Component from "vue-class-component";
import Vue from "vue";
import {userService} from "../../user/UserService";
import {analyticsController} from "../../user/analytics/AnalyticsController";
import {Prop} from "vue-property-decorator";
import {InAppSurveyConfiguration} from "../types/InAppSurveyConfiguration";

@Component
export default class InAppSurvey extends Vue {
  @Prop({required: true}) configurations!: InAppSurveyConfiguration[];

  private activeSurveyConfiguration: InAppSurveyConfiguration = null;
  private isDisplayed = false;
  private readonly excludedRoutes = ['Maintenance', 'Offline', 'StoreMobilePage', 'Update Error', 'Update']

  mounted() {
    this.configurations.forEach((configuration: InAppSurveyConfiguration) => {
      analyticsController.addListenerToTokatabEvent(configuration.triggerEvent, () => {
        if(!this.excludedRoutes.includes(this.$route.name)) {
          this.displaySurvey(configuration)
        }
      });
    })
  }

  public shouldDisplaySurvey(configuration: InAppSurveyConfiguration) {
    return !this.surveyHasBeenAnswered(configuration.surveyId) && analyticsController.areConditionsValid(configuration.conditions)
  }
  public surveyHasBeenAnswered(surveyId: string) {
    return analyticsController.isConditionValid({
      name: this.getAnsweredEventName(surveyId),
      compare: 'GREATER_EQUAL',
      amount: 1
    })
  }

  public displaySurvey(configuration: InAppSurveyConfiguration): boolean {
    if (this.shouldDisplaySurvey(configuration)) {
      this.activeSurveyConfiguration = configuration;
      // Must be set each time in case there is multiple survey at the same time
      // @ts-ignore
      window.qwarySettings = {
        surveyId : configuration.surveyId,
        popupHeight : '100%',
        popupWidth : '100%',
        layout : 'inline',
        container: 'qwary-widget',
        contact : {
          email : userService.user.email,
          firstName : userService.user.firstname,
          lastName : userService.user.lastname,
        }
      };

      this.isDisplayed = true;
      // Must use a timeout because qwary don't seems to be available directly
      setTimeout(
        () => {
          // @ts-ignore
          window.qwary.survey() // False negative
        }, 500)

      return true;
    }
    return false;
  }
  private closeSurvey() {
    // Use Analytics to handle already seen survey // TODO: could maybe be handled better using network check or something like that
    analyticsController.logAnalyticsEvent({
      title: this.getAnsweredEventName(this.activeSurveyConfiguration!.surveyId), category: 'InAppSurvey'
    }, 'Amplitude', true)

    this.isDisplayed = false;
    this.activeSurveyConfiguration = null;
  }

  /* Utils */
  private getAnsweredEventName(surveyId: string) {
    return 'answered ' + surveyId
  }
}
